import { useEffect, useState, useRef } from 'react';
import useIsMobile from 'tradera/hooks/use-is-mobile';
import { useSelector } from 'react-redux';
import { selectLocale } from 'tradera/state/language/selectors';

export const GoogleSignupButton = ({ googleAppId, onCallback }) => {
    const divRef = useRef(null);
    const isMobile = useIsMobile();
    const wasMobile = useRef(isMobile);

    const [googleButtonInitialized, setGoogleButtonInitialized] =
        useState(false);

    const locale = useSelector(selectLocale);

    useEffect(() => {
        if (!window.google) return;

        if (!googleButtonInitialized) {
            window.google.accounts.id.initialize({
                client_id: googleAppId,
                callback: onCallback
            });

            setGoogleButtonInitialized(true);
        }

        const renderButton = () => {
            window.google.accounts.id.renderButton(divRef.current, {
                theme: 'outline',
                size: 'medium',
                type: 'standard',
                text: 'continue_with',
                locale: locale,
                shape: 'rectangular',
                width: divRef.current.offsetWidth
            });
        };

        if (wasMobile.current !== isMobile) {
            renderButton();

            wasMobile.current = isMobile;

            return;
        }

        if (googleButtonInitialized) return;

        renderButton();
    }, [
        googleAppId,
        onCallback,
        locale,
        googleButtonInitialized,
        divRef,
        isMobile
    ]);

    return <div ref={divRef} className="mb-2 d-flex justify-content-center" />;
};
